module.exports = __webpack_public_path__ + "static/media/8794.73b033b8.png";